import { setRedirectDataStorage } from '../Services/RedirectDataService';

export const setLocationRedirectData = (pathname: string, search?: string) => {
  setRedirectDataStorage({
    pathname,
    search,
    redirectURL: `${pathname}${search ? `${search}` : ''}`
  });
};
